/**
 * useTheme — controle de tema da plataforma.
 *
 * Sistema de tokens:
 *   - Dark (padrão): nenhuma classe no <html>
 *   - Light: classe `.light` no <html>
 *   - System: detecta prefers-color-scheme e aplica `.light` se necessário
 *
 * Persiste em localStorage para evitar FOUC antes do React montar.
 */

const STORAGE_KEY = 'lumenise-theme';

export type ThemeValue = 'light' | 'dark' | 'system';

/** Aplica o tema ao DOM e salva em localStorage. */
export function applyTheme(theme: ThemeValue): void {
  const root = document.documentElement;
  root.classList.remove('light');

  if (theme === 'light') {
    root.classList.add('light');
  } else if (theme === 'system') {
    const preferLight = !window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (preferLight) root.classList.add('light');
  }
  // 'dark' = padrão, sem classe extra

  localStorage.setItem(STORAGE_KEY, theme);
}

/** Retorna o tema salvo ou 'dark' como fallback. */
export function getSavedTheme(): ThemeValue {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'light' || saved === 'dark' || saved === 'system') return saved;
  return 'dark';
}
